/// <amd-module name="Environments/Providers/Kubernetes/ZeroDataComponents" />
import { HyperLinks } from "Constants";
import * as Resources from "Environments/Providers/Kubernetes/Resources";
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Link } from "VSSUI/Link";
import { ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";
import { IKubernetesResourceDetails } from "./Types";

export interface IResourceAccessDeniedZeroDataProperties {
    subText: string;
    onActionClick: (resourceDetails: IKubernetesResourceDetails) => void;
    resourceDetails: IKubernetesResourceDetails;
    imagePath: string;
}

export class ResourceAccessDeniedZeroData extends VssComponent<IResourceAccessDeniedZeroDataProperties, {}>{
    constructor(props: IResourceAccessDeniedZeroDataProperties, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): React.ReactNode {
        const { subText, onActionClick, resourceDetails, imagePath } = this.props;
        return (
            <ZeroData
                className="k8s-resource-access-denied-error"
                primaryText={Resources.KubernetesAuthValidationTitleText}
                secondaryText={
                    <div className="flex flex-column">
                        <div>{Resources.KubernetesAuthValidationHelpText}</div>
                        <div className="page-content-top">
                            {subText}
                            <Link
                                href={HyperLinks.ResourceAccessDeniedLink}
                                target="_blank"
                                rel="nofollow noopener"
                            >
                                {Resources.LearnMoreText}
                            </Link>
                        </div>
                    </div>
                }
                imageAltText={Resources.KubernetesAuthValidationTitleText}
                imagePath={imagePath}
                actionText={Resources.ValidateText}
                actionType={ZeroDataActionType.ctaButton}
                onActionClick={(event, item) => onActionClick && onActionClick(resourceDetails)}
            />
        );
    }
}

export interface IResourceDeletedZeroDataProperties {
    imagePath: string;
}

export class ResourceDeletedZeroData extends VssComponent<IResourceDeletedZeroDataProperties, {}>{
    constructor(props: IResourceDeletedZeroDataProperties, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): React.ReactNode {
        return (
            <ZeroData
                className="k8s-resource-deleted-error"
                primaryText={""}
                secondaryText={
                    <div>
                        {Resources.KubernetesResourceDeletedHelpText}
                        <Link
                            href={HyperLinks.ResourceDeletedLink}
                            target="_blank"
                            rel="nofollow noopener"
                        >
                            {Resources.LearnMoreText}
                        </Link>
                    </div>
                }
                imageAltText={Resources.KubernetesResourceDeletedAltText}
                imagePath={this.props.imagePath}
            />
        );
    }
}
